// Polyfills for older browsers (Android 10 / Chrome 77 compatibility)

// Map polyfill (if needed)
if (typeof Map === 'undefined') {
  window.Map = function Map() {
    this._keys = [];
    this._values = [];
  };
  
  window.Map.prototype.set = function(key, value) {
    var index = this._keys.indexOf(key);
    if (index >= 0) {
      this._values[index] = value;
    } else {
      this._keys.push(key);
      this._values.push(value);
    }
    return this;
  };
  
  window.Map.prototype.get = function(key) {
    var index = this._keys.indexOf(key);
    return index >= 0 ? this._values[index] : undefined;
  };
  
  window.Map.prototype.has = function(key) {
    return this._keys.indexOf(key) >= 0;
  };
  
  window.Map.prototype['delete'] = function(key) {
    var index = this._keys.indexOf(key);
    if (index >= 0) {
      this._keys.splice(index, 1);
      this._values.splice(index, 1);
      return true;
    }
    return false;
  };
  
  window.Map.prototype.clear = function() {
    this._keys = [];
    this._values = [];
  };
  
  Object.defineProperty(window.Map.prototype, 'size', {
    get: function() {
      return this._keys.length;
    }
  });
}

// String.prototype.includes polyfill
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }
    
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

// String.prototype.startsWith polyfill
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

// String.prototype.endsWith polyfill
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

// Array.from polyfill
if (!Array.from) {
  Array.from = function(arrayLike) {
    var items = Object(arrayLike);
    var len = parseInt(items.length) || 0;
    var result = new Array(len);
    var i = 0;
    while (i < len) {
      result[i] = items[i];
      i++;
    }
    return result;
  };
}

// Object.entries polyfill
if (!Object.entries) {
  Object.entries = function(obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}

// Object.values polyfill
if (!Object.values) {
  Object.values = function(obj) {
    var values = [];
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        values.push(obj[key]);
      }
    }
    return values;
  };
}

// Element.prototype.closest polyfill
if (!Element.prototype.closest) {
  Element.prototype.closest = function(selector) {
    var el = this;
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) {
        return el;
      }
      el = el.parentElement || el.parentNode;
    }
    return null;
  };
}

// Element.prototype.matches polyfill
if (!Element.prototype.matches) {
  Element.prototype.matches = 
    Element.prototype.matchesSelector || 
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector || 
    Element.prototype.oMatchesSelector || 
    Element.prototype.webkitMatchesSelector ||
    function(s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s);
      var i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}

// CustomEvent polyfill
(function() {
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();

// Promise.finally polyfill
if (!Promise.prototype.finally) {
  Promise.prototype.finally = function(callback) {
    var constructor = this.constructor;
    return this.then(
      function(value) {
        return constructor.resolve(callback()).then(function() {
          return value;
        });
      },
      function(reason) {
        return constructor.resolve(callback()).then(function() {
          throw reason;
        });
      }
    );
  };
}